<script setup lang="ts">
/**
 * CaTextarea — pasangan CaInput untuk isian banyak baris.
 *
 * Aturan yang sama dan tidak bisa ditawar: font-size MINIMUM 16px. Di bawah itu
 * Android dan iOS melakukan zoom paksa begitu kolomnya disentuh, dan halaman
 * terasa rusak persis di detik pengguna mulai menempelkan datanya.
 *
 * `font-mono` opsional dipakai untuk daftar nomor: dengan lebar karakter yang
 * seragam, nomor yang salah panjang langsung terlihat oleh mata tanpa perlu
 * dihitung.
 */
withDefaults(
  defineProps<{
    modelValue?: string
    placeholder?: string
    rows?: number
    disabled?: boolean
    mono?: boolean
    id?: string
    describedby?: string
  }>(),
  { rows: 8 }
)
defineEmits<{ 'update:modelValue': [string] }>()
</script>

<template>
  <UTextarea
    :id="id"
    :model-value="modelValue"
    :placeholder="placeholder"
    :rows="rows"
    :disabled="disabled"
    :aria-describedby="describedby"
    class="w-full"
    :ui="{
      root: 'w-full',
      base: [
        'w-full rounded-control bg-page border border-line text-ink',
        // text-base! (16px) dipaksa — sama seperti CaInput: tanpa important,
        // text-sm bawaan Nuxt UI menang → 14px < 16px = zoom paksa di Android.
        'text-base! leading-relaxed placeholder:text-muted',
        mono ? 'font-mono' : '',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-ring-ca)]'
      ].join(' ')
    }"
    @update:model-value="(v: any) => $emit('update:modelValue', String(v))"
  />
</template>
